import { render, staticRenderFns } from "./CharacterCodes.vue?vue&type=template&id=507e8e9c&"
import script from "./CharacterCodes.vue?vue&type=script&lang=js&"
export * from "./CharacterCodes.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCodes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports